import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
interface BottomGradientBorderProps extends GeneralPropsType {
  id?: string;
  bottomHeight?: number;
  background?: "green_left_to_right" | "top_to_bottom" | "bottom_to_top" | "right_to_left" | "dark_blue_right_to_left" | "dark_blue_bottom_to_top" | "dark_blue_top_to_bottom" | "purple_gradient_full" | "purple_gradient" | "purple_gradient_full_secondary";
}
function BottomGradientBorder({
  children,
  className,
  background,
  onClick,
  bottomHeight = 0,
  id
}: BottomGradientBorderProps) {
  return <div id={id} onClick={onClick} className={clsx("relative rounded-2xl", styles.container, styles[background ?? "none"], className)} data-sentry-component="BottomGradientBorder" data-sentry-source-file="index.tsx">
            {children}
            <div style={{
      height: `${bottomHeight}px`
    }} className={clsx("absolute left-0 right-0 bottom-0", styles.gradient_bottom_border)}></div>
        </div>;
}
export default BottomGradientBorder;